module.exports = __webpack_public_path__ + "static/media/icon_brief_us.7aee7eab.svg";